import SharedStyles from "@components/Main/Shared/LeadFunnel/@styles/LeadFunnel.styles";

export default (theme) => {
	const sharedStyles = SharedStyles(theme);
	return Object.assign(sharedStyles, {
		//
	});
};
